import React from "react";
import styles from "../characteristicCustomForm.module.scss";
import editIcon from "../../../../static/images/edit-icon-blue.png";
import { EDIT } from "../../../../constants";

export const EditIcon = ({ editable, setEditable }) => {
  const handleEdit = () => {
    setEditable(true);
  };
  return (
    <div style={{ marginBottom: '2.5rem'}}>
      <h2 className={`${styles.tab_content_hdg}`}>
        {!editable && (
          <span className={`float-sm-right ${styles.tab_edit} handleEdit`} onClick={handleEdit}>
            <img src={editIcon} alt="edit" />
            {EDIT}
          </span>
        )}
      </h2>
    </div>
  );
};
